export default __webpack_public_path__ + "static/15-ca830138048fac441c3183ab28eb5a08.jpg";